import axios from 'axios'
import store from '@/store'
import QS from 'qs'
import router from '../router/index'
import { Message } from 'element-ui'
import { showFullScreenLoading, tryHideFullScreenLoading } from './loading.js';
import TokenManager from '@/utils/auth'

const showMessage = Symbol('showMessage')
// 重写，避免Message提示重复出现
class DonMessage {
  success (options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning (options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info (options, single = true) {
    this[showMessage]('info', options, single)
  }
  error (options, single = true) {
    this[showMessage]('error', options, single)
  }

  [showMessage] (type, options, single) {
    if (single) { // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}
var MessageOnce = new DonMessage()


const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_BASEURL || '',
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    }
})

// 创建新的API服务实例
const emiApiService = axios.create({
    baseURL: process.env.VUE_APP_EMI_API_URL || '',
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    }
})

export default service

// 为新的API服务添加拦截器
emiApiService.interceptors.request.use(
    config => {
        // 除非明确设置 showLoading 为 false，否则显示 loading
        if (config.showLoading !== false) {
            showFullScreenLoading();
        }

        if (!config.ignoreExpired && TokenManager.isExpiringSoon(0)) {
            MessageOnce.error({ message: '登录过期，请重新登录' });
            store.dispatch('logout');
            router.push('/login');
            return Promise.reject(new Error('Token has expired'));
        }

        const token = TokenManager.getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        // 处理 bot_number：当值为字符串 "null"（代表"公司"）时，转换为真正的 null
        if (config.params && config.params.bot_number === 'null') {
            config.params.bot_number = null;
        }
        if (config.data) {
            if (config.data instanceof FormData) {
                // 对于 FormData，当 bot_number 为 "null" 时，替换为真正的 null
                if (config.data.has('bot_number')) {
                    const botNumber = config.data.get('bot_number');
                    if (botNumber === 'null') {
                        config.data.delete('bot_number');
                        config.data.append('bot_number', null);
                    }
                }
            } else if (typeof config.data === 'object') {
                if (config.data.bot_number === 'null') {
                    config.data.bot_number = null;
                }
            }

        }
        // 处理 URL 查询参数中的 bot_number=null：保持参数，确保值为 null
        // axios 会自动将 null 值处理为字符串 "null" 在 URL 中，后端应该能正确解析
        if (config.url && config.url.includes('bot_number=null')) {
            // 保持 bot_number=null，不需要删除
            // axios 在处理 params 时会自动处理 null 值
        }
        
        return config;
    },
    error => Promise.reject(error)
);

emiApiService.interceptors.response.use(
    response => {
        tryHideFullScreenLoading()
        if (response.status === 200) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        tryHideFullScreenLoading();

        // 如果是取消请求的错误，不显示错误提示
        if (error.name === 'CanceledError' || error.message === 'canceled' || error.code === 'ERR_CANCELED') {
            return Promise.reject(error);
        }

        const status = error.response ? error.response.status : null;
        if (status === 401) {
            // 修改这里的错误提示
            MessageOnce.error({ message: '登录过期，请重新登录' });
            // 处理未授权错误
            store.dispatch('logout');
            router.push('/login');
        } else if (status === 500) {
            MessageOnce.error({ message: '服务器错误，请稍后再试！' });
        } else {
            MessageOnce.error({ message: error.message || '请求错误' });
        }
        return Promise.reject(error);
    }
)

service.interceptors.request.use(
    config => {
        // 除非明确设置 showLoading 为 false，否则显示 loading
        if (config.showLoading !== false) {
            showFullScreenLoading();
        }

        if (!config.ignoreExpired && TokenManager.isExpiringSoon(0)) {
            MessageOnce.error({ message: '登录过期，请重新登录' });
            store.dispatch('logout');
            router.push('/login');
            return Promise.reject(new Error('Token has expired'));
        }

        const token = TokenManager.getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        // 处理 bot_number：当值为字符串 "null"（代表"公司"）时，转换为真正的 null
        if (config.params && config.params.bot_number === 'null') {
            config.params.bot_number = null;
        }
        if (config.data) {
            if (config.data instanceof FormData) {
                // 对于 FormData，当 bot_number 为 "null" 时，替换为真正的 null
                if (config.data.has('bot_number')) {
                    const botNumber = config.data.get('bot_number');
                    if (botNumber === 'null') {
                        config.data.delete('bot_number');
                        config.data.append('bot_number', null);
                    }
                }
            } else if (typeof config.data === 'object') {
                if (config.data.bot_number === 'null') {
                    config.data.bot_number = null;
                }
            }

        }
        // 处理 URL 查询参数中的 bot_number=null：保持参数，确保值为 null
        // axios 会自动将 null 值处理为字符串 "null" 在 URL 中，后端应该能正确解析
        if (config.url && config.url.includes('bot_number=null')) {
            // 保持 bot_number=null，不需要删除
            // axios 在处理 params 时会自动处理 null 值
        }
        
        return config;
    },
    error => Promise.reject(error)
);

service.interceptors.response.use(
    response => {
        tryHideFullScreenLoading()
        if (response.status === 200) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        tryHideFullScreenLoading();

        // 如果是取消请求的错误，不显示错误提示
        if (error.name === 'CanceledError' || error.message === 'canceled' || error.code === 'ERR_CANCELED') {
            return Promise.reject(error);
        }

        const status = error.response ? error.response.status : null;
        if (status === 401) {
            // 修改这里的错误提示
            MessageOnce.error({ message: '登录过期，请重新登录' });
            // 处理未授权错误
            store.dispatch('logout');
            router.push('/login');
        } else if (status === 500) {
            MessageOnce.error({ message: '服务器错误，请稍后再试！' });
        } else {
            MessageOnce.error({ message: error.message || '请求错误' });
        }
        return Promise.reject(error);
    }
)



// 提取id与url拼接
function appendIdToUrl(url, params) {
    if (params.id) {
        url = `${url}/${params.id}`;
        delete params.id; 
    }
    return url;
}

/**
 * 封装get方法
 * @param url
 * @param params
 * @param config - 可以包含 showLoading: false 来禁用加载动画
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
    url = appendIdToUrl(url, params);
    return new Promise((resolve, reject) => {
        service.get(url, { params: params, ...config })
            .then(response => resolve(response.data))
            .catch(err => reject(err.data))
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}  

/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function post(url, params = {}, config = {}) {
    url = appendIdToUrl(url, params);
    let data = config ? params : QS.stringify(params);
    
    return new Promise((resolve, reject) => {
        service.post(url, data, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 封装put请求
 * @param {string} url - 请求URL
 * @param {object} params - 请求参数
 * @param {object} config - 请求配置
 * @returns {Promise}
 */
export function put(url, params = {}, config = {}) {
    url = appendIdToUrl(url, params);
    
    return new Promise((resolve, reject) => {
        service.put(url, params, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 封装delete请求
 * @param {string} url - 请求的URL
 * @param {string|number} id - 要删除的资源的ID
 * @param {object} config - 请求配置
 * @param {boolean} hideLoading - 是否隐藏加载动画
 * @returns {Promise} - 返回一个Promise对象
 */
export function remove(url, id, config = {}) {
    return new Promise((resolve, reject) => {
        const fullUrl = `${url}/${id}`;
        service.delete(fullUrl, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 封装上传文件请求
 * @param url
 * @param formData
 * @param config - 可以包含 showLoading: false 来禁用加载动画
 * @returns {Promise}
 */
export function uploadfile(url, formData, config = {}) {
    const uploadConfig = { 
        headers: {
            'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime(),
            'authorization': 'Bearer ' + store.getters.getToken 
        },
        ...config
    };

    return new Promise((resolve, reject) => {
        service.post(url, formData, uploadConfig)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (uploadConfig.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

// ========== 新API服务器的请求方法 ==========

/**
 * 新API服务器的GET请求
 * @param url
 * @param params
 * @param config
 * @returns {Promise}
 */
export function getEmiApi(url, params = {}, config = {}) {
    url = appendIdToUrl(url, params);
    return new Promise((resolve, reject) => {
        emiApiService.get(url, { params: params, ...config })
            .then(response => resolve(response.data))
            .catch(err => reject(err.data))
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 新API服务器的POST请求
 * @param url
 * @param params
 * @param config
 * @returns {Promise}
 */
export function postEmiApi(url, params = {}, config = {}) {
    url = appendIdToUrl(url, params);
    let data = config ? params : QS.stringify(params);
    
    return new Promise((resolve, reject) => {
        emiApiService.post(url, data, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 新API服务器的PUT请求
 * @param url
 * @param params
 * @param config
 * @returns {Promise}
 */
export function putEmiApi(url, params = {}, config = {}) {
    url = appendIdToUrl(url, params);
    
    return new Promise((resolve, reject) => {
        emiApiService.put(url, params, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 新API服务器的DELETE请求
 * @param url
 * @param id
 * @param config
 * @returns {Promise}
 */
export function removeEmiApi(url, id, config = {}) {
    return new Promise((resolve, reject) => {
        const fullUrl = `${url}/${id}`;
        emiApiService.delete(fullUrl, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (config.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}

/**
 * 新API服务器的文件上传请求
 * @param url
 * @param formData
 * @param config - 可以包含 showLoading: false 来禁用加载动画
 * @returns {Promise}
 */
export function uploadfileEmiApi(url, formData, config = {}) {
    const uploadConfig = { 
        headers: {
            'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime(),
            'authorization': 'Bearer ' + store.getters.getToken 
        },
        ...config
    };

    return new Promise((resolve, reject) => {
        emiApiService.post(url, formData, uploadConfig)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => {
                if (uploadConfig.showLoading !== false) {
                    tryHideFullScreenLoading();
                }
            });
    });
}


